import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import axios from "axios";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const navigation = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // API endpoint for changing password
  const { callApi, loading, error, data } = useApi(
    "/api/change-password-first-time",
    {
      method: "POST",
      autoCall: false,
    },
  );

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Password Mismatch",
        text: "New password and confirm password do not match.",
      });
      return;
    }

    try {
      const response = await callApi({
        newPassword: formData.newPassword,
      });
      console.log(response)
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Password Changed",
          text:
            response?.data?.message ||
            "Your password has been updated successfully.",
        }).then(() => {
          window.location.href = "/employee-dashboard";
        });
      }

      setFormData({
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          err.response?.data?.message ||
          err.message ||
          "Something went wrong, please try again.",
      });
    }
  };

  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          {/* Left Section with Video Background */}
          <div className="col-lg-7">
            <div className="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
              <div className="bg-overlay-img">
                <ImageWithBasePath
                  src="/assets/img/bg/bg-01.png"
                  className="bg-1"
                  alt="Img"
                />
                <ImageWithBasePath
                  src="/assets/img/bg/bg-02.png"
                  className="bg-2"
                  alt="Img"
                />
                <ImageWithBasePath
                  src="/assets/img/bg/bg-03.png"
                  className="bg-3"
                  alt="Img"
                />
              </div>
              <div className="authentication-card-container">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="video-background"
                >
                  <source
                    src="/assets/img/video/team1ConsultingBannervideo.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>

          {/* Right Section with Change Password Form */}
          <div className="col-lg-5 col-md-12 col-sm-12">
            <div className="login-form-container d-flex justify-content-center align-items-center vh-100">
              <div className="form-wrapper w-100 px-4">
                <form className="rounded" onSubmit={handleSubmit}>
                  <div className="text-center mb-4">
                    <div
                      className="logo-wrapper mx-auto"
                      style={{ maxWidth: "130px" }}
                    >
                      <ImageWithBasePath
                        src="/assets/img/logo/team1-consultancy1.png"
                        className="img-fluid logo-img"
                        alt="Logo"
                      />
                    </div>
                    <div
                      className="logo-wrapper mx-auto"
                      style={{ maxWidth: "180px" }}
                    >
                      <ImageWithBasePath
                        src="/assets/img/logo/weconnectlogo.png"
                        className="img-fluid logo-img"
                        alt="Logo"
                      />
                    </div>
                  </div>

                  <div className="text-center mb-3">
                    <h2 className="mb-2">Change Password</h2>
                    <p className="mb-0 text-muted">
                      Please enter your new password below and confirm it to
                      complete the password reset process.
                    </p>
                  </div>

                  {/* New Password */}
                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        type="newPassword"
                        name="newPassword"
                        onChange={handleChange}
                        className="form-control border-end-0"
                        required
                        placeholder="New Password"
                      />
                      <span className="input-group-text border-start-0">
                        <i className="ti ti-lock" />
                      </span>
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        type="confirmPassword"
                        name="confirmPassword"
                        onChange={handleChange}
                        className="form-control border-end-0"
                        required
                        placeholder="Confirm Password"
                      />
                      <span className="input-group-text border-start-0">
                        <i className="ti ti-lock-check" />
                      </span>
                    </div>
                  </div>

                  <div className="mb-4 mt-2">
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={loading}
                    >
                      {loading ? "Updating Password..." : "Change Password"}
                    </button>
                  </div>
                </form>

                <div className="text-center text-gray-9 mt-5">
                  © {new Date().getFullYear()} WeConnect. All rights reserved.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
